import "./tabs.scss";

import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import React, { useEffect, useState } from "react";
import { DatePicker } from "antd";
import Loading from "../../../loader/loader";
import NkTable from "../../nktable";
import StatusSelect from "../modals/c3toc3-filter";
import { getTabC3TransactionList } from "../../../../service/profile-ras-service";
import moment from "moment";

const C3transactiontab = ({ userId }) => {
  const [searchBy, setSearchBy] = useState("receiver");
  const [searchByValue, setSearchByValue] = useState("");
  const [Status, setStatus] = useState("");
  const [filterValues, setFilterValues] = useState(false);
  const [noOfFiltersSelected, setNoOfFiltersSelected] = useState(false);
  const [filtersSelected, setFiltersSelected] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState();
  const [dataLoading, setDataLoading] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [rakTab, setRakTab] = useState([]);
  const [sizeShow, setSizeShow] = useState();
  const [selectedOption, setSelectedOption] = useState([]);

  const request = {
    page: 1,
    size: 10,
    beneficiaryName: "",
    sender: "",
    fromDate: "",
    toDate: "",
    searchType: "",
    searchCountry: "",
    searchStatus: "",
    c3REF: "",
    rakRef: "",
    referralCode: "",
    profileStatus: "",
    beneficiaryMobile: "",
  };
  const [filterForm, setFilterForm] = useState(request);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    current: 1,
  });

  const columns = [
    {
      dataField: "status",
      text: "status",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
    },
    {
      dataField: "createdDate",
      text: "Date",
      sort: true,
      style: { minWidth: "100px", textAlign: "Left" },
      formatter: (cell, row) => {
        return moment((row && row.createdDate) || null).format(
          "DD-MM-YY  HH:mm:ss"
        );
      },
    },
    {
      dataField: "beneficiaryName",
      text: "Beneficiary",
      sort: false,
      style: { minWidth: "150px", textAlign: "left" },
    },

    {
      dataField: "beneficiaryMobile",
      text: "Receiver",
      sort: false,
      style: { minWidth: "100px", textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },

    {
      dataField: "sent",
      text: "SEND(AED)",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
    },
    {
      dataField: "fee",
      text: "FEE",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
    },
    {
      dataField: "TOTAL DEBITED",
      text: "TOTAL DEBITED ",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
      formatter: (cell, row) => {
        return (row && row.fee && row.sent && row.fee + row.sent) || null;
      },
    },
    {
      dataField: "c3REF",
      text: "REF NO",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
    },
  ];
  const options = [
    { value: "Successful", label: "SUCCESSFUL" },
    { value: "Pending", label: "PENDING" },
    { value: "Reversed", label: "REVERSED" },
  ];

  const [id, setId] = useState();

  useEffect(() => {
    if (userId) {
      setId(userId);
    }
  }, []);

  useEffect(() => {
    if (id) {
      getTabC3Transaction(filterForm, id);
    }
  }, [id]);

  useEffect(() => {
    if (filterForm && filterForm.isFilter) {
      getTabC3Transaction(filterForm, id);
    }
  }, [filterForm]);

  const getTabC3Transaction = (request, id) => {
    request.size = sizeShow || 10;
    setDataLoading(true);
    getTabC3TransactionList(request, id)
      .then((res) => {
        setDataLoading(false);
        setRakTab(res.data.moneyTransferTransactions || []);
        setPagination({
          ...pagination,
          pageSize: sizeShow || 10,
          total: res.data.totalCount,
          current: request.page,
        });
      })
      .catch((err) => {
        setDataLoading(false);

        setRakTab([]); // TODO -NEED TO REMOVE
      });
  };

  const handleFilter = () => {
    let request = {};
    if (searchBy === "receiver") {
      request = {
        ...filterForm,
        beneficiaryMobile: searchByValue,
        beneficiaryName: null,
      };
    } else if (searchBy === "beneficiary") {
      request = {
        ...filterForm,
        beneficiaryName: searchByValue,
        beneficiaryMobile: null,
      };
    }

    request.fromDate =
      (fromDate && moment(fromDate).format("YYYY-MM-DD")) || null;
    request.toDate = (toDate && moment(toDate).format("YYYY-MM-DD")) || null;
    request.isFilter = true;
    request.searchStatus = Status;
    request.page = 1;
    setFilterForm(request);
  };

  let searchByValuePlaceholder = "";
  if (searchBy === "receiver") {
    searchByValuePlaceholder = "971501234567";
  } else if (searchBy === "beneficiary") {
    searchByValuePlaceholder = "Amit Pandit";
  }

  const statusFilter = () => {
    setNoOfFiltersSelected(selectedOption.length);
    setShowFilterModal(false);

    setFiltersSelected(true);
    selectedOption.map((option) => {
      switch (option.label) {
        case "SUCCESSFUL":
          setStatus("Successful");
          return setFilterValues(!filterValues);
        case "PENDING":
          setStatus("Pending");
          return setFilterValues(!filterValues);
        case "REVERSED":
          setStatus("Reversed");
          return setFilterValues(!filterValues);
        default:
          return "";
      }
    });
  };

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedOption([{ ...selectedOption }]);
    }
  };

  const resetFilter = () => {
    setSearchBy("receiver");
    request.isFilter = true;
    setFromDate(null);
    setToDate(null);
    setStatus("");
    setFilterValues(false);
    setFiltersSelected(false);
    setSearchByValue("");
    setSelectedOption([]);
    setRakTab([]);
    setFilterForm(request);
  };
  const dateFormat = "DD-MM-YY";
  const customFormat = (value) => `${value.format(dateFormat)}`;
  console.log("searchBy", searchBy);

  return (
    <>
      <Row
        style={{ marginLeft: "0px", marginRight: "0px", padding: "12px 0px" }}
      >
        <Col lg="2" className="form-input-padding-tab">
          <FormGroup>
            <label
              className="form-control-label"
              htmlFor="exampleFormControlSelect1"
            >
              Search by
            </label>
            <Input
              id="exampleFormControlSelect1"
              style={{ height: "28px" }}
              type="select"
              value={searchBy}
              onChange={(e) => {
                setSearchBy(e.target.value);
                setSearchByValue("");
              }}
            >
              <option value="receiver">Receiver</option>
              <option value="beneficiary">Beneficiary</option>
            </Input>
          </FormGroup>
        </Col>
        <Col lg="2" className="form-input-padding-tab">
          <FormGroup>
            <label className="form-control-label" htmlFor="example3cols2Input">
              Search for
            </label>
            <Input
              id="example3cols2Input"
              placeholder={searchByValuePlaceholder}
              type="text"
              style={{ height: "27px" }}
              onKeyPress={(e) => e.charCode === 13 && handleFilter(true)}
              onChange={(e) =>
                setSearchByValue(
                  e.target && e.target.value && e.target.value.trim()
                )
              }
              value={searchByValue}
            />
          </FormGroup>
        </Col>
        <Col lg="2" className="form-input-padding-tab">
          <FormGroup>
            <Label className="form-control-label" htmlFor="example3cols2Input">
              From
            </Label>
            <DatePicker
              placeholder="DD-MM-YY"
              className="formcontrol-date"
              onChange={(e, dateString) => {
                if (dateString && dateString != "") {
                  setFromDate(moment(dateString, dateFormat));
                } else {
                  setFromDate(null);
                }
              }}
              value={fromDate}
              format={customFormat}
            />
          </FormGroup>
        </Col>
        <Col lg="2" className="form-input-padding-tab">
          <FormGroup>
            <Label className="form-control-label" htmlFor="example3cols2Input">
              To
            </Label>
            <DatePicker
              placeholder="DD-MM-YY"
              className="formcontrol-date"
              onChange={(e, dateString) => {
                if (dateString && dateString != "") {
                  setToDate(moment(dateString, dateFormat));
                } else {
                  setToDate(null);
                }
              }}
              value={toDate}
              format={customFormat}
            />
          </FormGroup>
        </Col>
        <div
          lg="1"
          className="form-input-padding-tab"
          style={{ marginTop: "2px" }}
        >
          <FormGroup>
            <Label
              className="form-control-label"
              htmlFor="exampleFormControlSelect1"
            >
              Filter by
            </Label>
            <div>
              <Button
                style={{ width: "100%", height: "26px" }}
                color="primary"
                type="button"
                id="example3cols2Input"
                className="filter-button"
                onClick={() => setShowFilterModal(true)}
              >
                <div>
                  {" "}
                  <i class="fas fa-filter"></i>
                </div>
              </Button>
            </div>
          </FormGroup>

          <span style={{ fontSize: 8 }}>
            {filtersSelected && noOfFiltersSelected > 0 ? (
              <>
                <h6 style={{ display: "flex", alignItems: "center" }}>
                  Selected({noOfFiltersSelected})
                  <i
                    class="fas fa-window-close"
                    style={{ cursor: "pointer", paddingLeft: "5px" }}
                    onClick={() => {
                      setSearchByValue("");
                      resetFilter();
                    }}
                  />
                </h6>
              </>
            ) : (
              <></>
            )}
          </span>
        </div>
        <Col
          lg="1"
          style={{ marginTop: "9px" }}
          className="form-input-padding-tab"
        >
          <FormGroup>
            <Label
              className="form-control-label"
              htmlFor="example3cols2Input"
            ></Label>
            <div>
              <Button
                type="button"
                style={{
                  width: "100%",
                  background: "#e91d24",
                  color: "white",
                  height: "26px",
                  border: "1px solid rgb(233, 29, 36)",
                }}
                id="example3cols2Input"
                className="filter-button"
                onClick={() => handleFilter(true)}
              >
                <div>
                  <i class="fas fa-search"></i>
                </div>
              </Button>
            </div>
          </FormGroup>
        </Col>
        <Col
          lg="1"
          style={{ marginTop: "9px" }}
          className="form-input-padding-tab"
        >
          <FormGroup>
            <Label
              className="form-control-label"
              htmlFor="example3cols2Input"
            ></Label>
            <div>
              <Button
                color="light"
                type="button"
                style={{ width: "100%", height: "26px" }}
                id="example3cols2Input"
                className="filter-button"
                onClick={() => resetFilter()}
              >
                <div
                  style={{
                    fontSize: "12px",
                  }}
                >
                  {" "}
                  <i class="fas fa-redo-alt 2px"></i> Reset
                </div>
              </Button>
            </div>
          </FormGroup>
        </Col>
      </Row>
      {rakTab.length < 0 ? (
        <>
          <Card
            className="mb-4"
            style={{
              display: "flex",
              flex: 1,
              textAlign: "center",
              justifyContent: "center",
              padding: "1.25rem 1.5rem",
            }}
          >
            <CardBody>
              <h3 className="mb-0">No Records Found</h3>
              {/* <h1 className="mb-0">Sorry ! We cannot find it</h1>
              <h3 className="mb-0">
                Enter a different search term or remove any filters and try
                again
              </h3> */}
            </CardBody>
          </Card>
        </>
      ) : (
        <>
          <Row style={{ padding: "1.25rem 0.5rem" }}>
            <div className="col card-parent">
              <Card>
                {dataLoading ? (
                  <div style={{ textAlign: "center" }}>
                    <Loading />
                  </div>
                ) : (
                  <>
                    <NkTable
                      filename={"All-User-List"}
                      data={rakTab}
                      columns={columns}
                      pagination={pagination}
                      onPagechange={(page) => {
                        setFilterForm({
                          ...filterForm,
                          page: page,
                          isFilter: true,
                        });
                      }}
                      showSizeChanged={(pageSize) => {
                        setSizeShow(pageSize);
                        setFilterForm({
                          ...filterForm,
                          page: pageSize,
                          isFilter: true,
                        });
                      }}
                    />
                  </>
                )}
              </Card>
            </div>
          </Row>
        </>
      )}
      <StatusSelect
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        handleChange={handleChange}
        options={options}
        selectedOption={selectedOption}
        statusFilter={statusFilter}
        placeholder="Status"
      />
    </>
  );
};
export default C3transactiontab;
